declare global {
  interface Window {
    Wooptima: any;
  }
}

export const // React app enviroment
  REACT_APP_ENV: "development" | "staging" | "test" | "production" | string =
    process.env.REACT_APP_ENV_OVERRIDE
      ? process.env.REACT_APP_ENV_OVERRIDE
      : process.env.NODE_ENV,
  // React app root ref
  REACT_APP_ROOT: HTMLElement =
    document.getElementById(process.env.REACT_APP_ROOT || "root") ??
    document.body,
  // WordPress base URL
  WP_BASE_URL: string =
    REACT_APP_ENV === "staging"
      ? new URL(window.location.toString()).searchParams.get("remote")
        ? `https://${new URL(window.location.toString()).searchParams.get(
            "remote"
          )}`
        : process.env.REACT_APP_WP_STAGE_LOCAL_URL ?? "/"
      : "/",
  // WordPress plugin base path
  WP_PLUGIN_BASE_PATH: string =
    REACT_APP_ENV === "development"
      ? "."
      : `/wp-content/plugins/wooptima/modules/${process.env.WOOPTIMA_WP_MODULE_NAME}`,
  // WordPress plugin nonce (authorization token)
  WP_PLUGIN_AUTH_NONCE: string =
    REACT_APP_ROOT?.getAttribute("data-nonce") ?? "",
  REACT_APP_PRODUCT_ID: string =
    REACT_APP_ENV === "staging"
      ? new URL(window.location.toString()).searchParams.get("id") || ""
      : REACT_APP_ROOT.getAttribute("data-id") ?? "",
  REACT_APP_PRODUCT_TYPE: string =
    REACT_APP_ENV === "staging"
      ? new URL(window.location.toString()).searchParams.get("type") || ""
      : REACT_APP_ROOT.getAttribute("data-type") ?? "simple",
  REACT_APP_DATA: any = // Check demo data from ?data
    REACT_APP_ENV === "production"
      ? typeof window.Wooptima == "object" &&
        "productAreaData" in window.Wooptima
        ? window.Wooptima?.productAreaData
        : {}
      : {};
